import React, { useState } from 'react';
import { radioStyles as styles } from './FormFieldsV3InlineStyles';
import LabelAndTooltip from './LabelAndTooltip';
import InfoAndError from './InfoAndErrorLabel';

interface IRadioProps {
  options: {
    key: string;
    value: string | number | boolean;
    text: string;
    icon?: React.JSX.Element;
  }[];
  selectedValue?: string | number | boolean;
  onChange: (value: any) => void;
  labelText?: string;
  tooltipText?: string;
  infoText?: string;
  errorText?: string;
  id?: string;
}

const Radio = ({
  options,
  selectedValue,
  onChange,
  labelText,
  tooltipText,
  infoText,
  errorText,
  id,
}: IRadioProps) => {
  const [selected, setSelected] = useState<
    string | number | boolean | null | undefined
  >(
    options
      .map(({ value }) => value)
      .includes(selectedValue as string | number | boolean)
      ? selectedValue
      : null,
  );

  const handleOptionClick = (optionValue: string | number | boolean) => {
    setSelected(optionValue);
    onChange(optionValue);
  };

  return (
    <div style={styles.container} id={id}>
      {labelText && (
        <LabelAndTooltip labelText={labelText} tooltipText={tooltipText} />
      )}
      <div style={styles.options}>
        {options.map((option) => (
          <div
            onClick={() => handleOptionClick(option.value)}
            style={{
              ...styles.label,
              ...(option.value === selected ? styles.selected : {}),
            }}
          >
            {option.icon ? <div style={styles.icon}>{option.icon}</div> : null}
            {option.text}
          </div>
        ))}
      </div>
      <InfoAndError errorText={errorText} infoText={infoText} />
    </div>
  );
};

export default Radio;
